










































































import Component from 'vue-class-component'
import { Vue, Prop, Watch } from 'vue-property-decorator'
import Delivery from '@/dto/deliveries/Delivery'
import DictionariesService from '@/services/DictionariesService'
import { Errors } from '@/dto/ErrorsResponse'

@Component
export default class BoxForm extends Vue {
  dictionaries = DictionariesService
  sizes = ''

  @Prop(Object)
  model: Delivery

  @Prop(Object)
  errors: Errors

  onInputSizes(value: string) {
    const values = (value.match(/\d+(\.\d+)?/g) || []).slice(0, 3)
    this.sizes = values.join(' ')
  }

  @Watch('sizes')
  setSizes(value: string) {
    const [maxHeight, maxLength, maxWidth] = value.split(' ')

    this.model.maxHeight = parseInt(maxHeight) || 0
    this.model.maxLength = parseInt(maxLength) || 0
    this.model.maxWidth = parseInt(maxWidth) || 0
  }

  @Watch('model', { immediate: true })
  clearSizes() {
    const { maxHeight = '', maxLength = '', maxWidth = '' } = this.model
    this.sizes = [maxHeight, maxLength, maxWidth].filter(size => size).join(' ')
  }
}
